import { render, staticRenderFns } from "./RoutinePreview.vue?vue&type=template&id=4f8b8fc5&scoped=true"
import script from "./RoutinePreview.vue?vue&type=script&lang=js"
export * from "./RoutinePreview.vue?vue&type=script&lang=js"
import style0 from "./RoutinePreview.vue?vue&type=style&index=0&id=4f8b8fc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b8fc5",
  null
  
)

export default component.exports